/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {useCallback, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {useSelector} from 'react-redux';

import {uploadUserLogo} from 'utils/fetch';
import {formatFileSize} from 'utils/common';
import OutsideClickHandler from 'react-outside-click-handler';
import Image from 'assets/svgs/common/image-black.svg';
import Folder from 'assets/svgs/common/folder.svg';
import CloudImage from 'assets/svgs/file-upload/cloud.svg';
import CheckIcon from 'assets/svgs/actions/check.svg';
import Search from 'assets/svgs/common/search.svg';
import ServerCategories from './ServerCategories';

import './style.scss';

const basicUserSelector = makeSelectBasicUser();

const FileUpload = ({
  type,
  typeKey,

  onSelect,
  onClose,
}) => {
  const userDetails = useSelector(basicUserSelector);
  const [preview, setPreview] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [file, setFile] = useState();
  const [progress, setProgress] = useState(40);
  const [searchKey, setSearchKey] = useState('');
  const [filter, setFilter] = useState(1);

  const fileState = {
    Select: 'SELECT',
    Uploading: 'UPLOADING',
    Uploaded: 'UPLOADED',
    Server: 'SERVER',
  };

  const [currentSection, setCurrentSection] = useState(fileState.Select);

  const uploadFile = async (file) => {
    const savedFile = await uploadUserLogo({
      file,
      authToken: userDetails.authToken,
      type,
      userId: userDetails._id,
    });

    setProgress(100);
    setCurrentSection(fileState.Uploaded);

    const json = await savedFile.json();
    const fileName = json.logo;

    setFile(fileName);
    onSelect(fileName);
  };

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreview(e.target.result);
      };

      reader.readAsDataURL(file);
      setSelectedFile(file);
      setCurrentSection(fileState.Uploading);

      uploadFile(file);
    }
  }, []);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: 'image/jpeg,image/webp, image/png, image/svg+xml',
  });

  const renderDropzone = () => (
    <div className="featured-img-uploaded upload-modal w-100">
      <div className="uploaded-img d-flex justify-content-center">
        <div {...getRootProps()} className="w-100">
          <input {...getInputProps()} />
          <div className="d-flex justify-content-center align-items-center flex-column h-100">
            <img src={CloudImage} alt="" />
            <p className="px-1 mt-2">
              Drag and Drop or <span className="text-gold">Browse</span> to
              upload
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderUploading = () => (
    <div className="d-flex w-100 uploading-section">
      <div className="left d-flex w-100">
        <img
          alt=""
          src={preview}
          className="ml-2 mt-2"
          height={90}
          width={100}
        />
        <div className="d-flex flex-column upload-area justify-content-center ml-2">
          <span>{selectedFile.name}</span>
          <span className=" text-light-gray">
            {formatFileSize(selectedFile.size)}
          </span>
        </div>
      </div>
      <div className="right w-100 d-flex align-items-center">
        <div className="progress-upload mx-4 w-100">
          <div style={{width: `${progress}%`}} className="progress-inner"></div>
        </div>
      </div>
    </div>
  );

  const renderUploaded = () => (
    <div className="d-flex w-100 uploading-section">
      <div className="left d-flex w-100">
        <img
          alt=""
          src={preview}
          className="ml-2 mt-2"
          height={90}
          width={100}
        />
        <div className="d-flex flex-column justify-content-center ml-2 upload-area">
          <span>{selectedFile.name}</span>
          <span className=" text-light-gray">
            {formatFileSize(selectedFile.size)}
          </span>
        </div>
      </div>
      <div className="right w-100 d-flex align-items-end justify-content-end pr-3 pb-3">
        <img
          aria-hidden
          onClick={() => {
            onSelect(file);
          }}
          alt=""
          src={CheckIcon}
          className="pointer"
        />
      </div>
    </div>
  );

  const renderServerCategory = () => (
    <ServerCategories
      filter={filter}
      userDetails={userDetails}
      onSelectLogo={(logo) => {
        onSelect(logo);
      }}
      type={type}
      typeKey={typeKey}
      searchKey={searchKey}
    />
  );

  const renderServer = () => (
    <div className="gallery-search w-100">
      <label className="d-flex">
        Select a logo from Server
        <ul className="d-flex ml-auto mr-0 p-0 mb-0">
          <li>
            <a
              href="#test"
              onClick={(e) => {
                e.preventDefault();
                setFilter(1);
              }}
              className={`${filter === 1 ? 'active' : ''}`}
            >
              1
            </a>
          </li>
          <li>
            <a
              href="#test"
              onClick={(e) => {
                e.preventDefault();
                setFilter(2);
              }}
              className={`${filter === 2 ? 'active' : ''}`}
            >
              2
            </a>
          </li>
          <li>
            <a
              href="#test"
              onClick={(e) => {
                e.preventDefault();
                setFilter(3);
              }}
              className={`${filter === 3 ? 'active' : ''}`}
            >
              3
            </a>
          </li>
        </ul>
      </label>
      <div className="form-search">
        <span>
          <img src={Search} alt="" />
        </span>
        <input
          type="search"
          value={searchKey}
          onChange={(e) => setSearchKey(e.target.value)}
          placeholder="Search"
        />
      </div>
    </div>
  );

  const renderSection = () => {
    if (fileState.Select === currentSection) return renderDropzone();

    if (fileState.Uploading === currentSection) return renderUploading();

    if (fileState.Uploaded === currentSection) return renderUploaded();
    return renderServer();
  };

  return (
    <div className="featured-img-popup">
      <div className="overlay"></div>

      <div className="box-popup d-flex justify-content-center align-items-center">
        <OutsideClickHandler
          onOutsideClick={() => {
            onClose();
          }}
        >
          <>
            <div className="content-popup">
              <div className="d-flex">
                <div className="tab-nav">
                  <ul
                    className="nav nav-pills m-0"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <a
                        className={`nav-link  ${
                          currentSection === fileState.Select ? 'active' : ''
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (currentSection === fileState.Uploading) return;

                          setCurrentSection(fileState.Select);
                        }}
                        data-toggle="pill"
                        href="#test"
                        role="tab"
                        aria-controls="pills-upload-logo"
                        aria-selected="true"
                      >
                        <img className="mr-2" src={Image} alt="" /> Upload Logo
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link  ${
                          currentSection === fileState.Server ? 'active' : ''
                        }`}
                        data-toggle="pill"
                        href="#test"
                        onClick={(e) => {
                          e.preventDefault();
                          if (currentSection === fileState.Uploading) return;
                          setCurrentSection(fileState.Server);
                        }}
                        role="tab"
                        aria-controls="pills-select-logo"
                        aria-selected="false"
                      >
                        <img className="mr-2" src={Folder} alt="" /> Select Logo
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane d-flex"
                    id="pills-upload-logo"
                    role="tabpanel"
                    aria-labelledby="pills-upload-logo-tab"
                  >
                    {renderSection()}
                  </div>
                </div>
              </div>
              {currentSection === fileState.Server && renderServerCategory()}
            </div>
          </>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default FileUpload;
